import { useEffect } from 'react';

/****************
 * KEEP ASKING UNTIL THE RECORD ENDS. Guillaume, 2026-10-07: "these row limit
 * should not exist anywhere".
 *
 * A paged list used to stop at its first page unless somebody pressed "Show
 * more", and a filter only ever searched what had been fetched: "465 of 500
 * closed trades (690 total, not all loaded)". Given an infinite query, this
 * fetches the next page whenever there is one and none is in flight, so the
 * list fills to the end on its own and every filter sees the whole record.
 *
 * It stops on an error rather than retrying in a loop: the query's own retry
 * has already run, and the screen shows what it holds with the total beside it.
 ****************/
export type PagedQueryState = { hasNextPage: boolean; isFetchingNextPage: boolean; isError: boolean };

/** True when another page exists, none is in flight, and the last one did not fail. */
export function shouldFetchNextPage(q: PagedQueryState): boolean {
  return q.hasNextPage && !q.isFetchingNextPage && !q.isError;
}

export function useFetchAllPages(q: PagedQueryState & { fetchNextPage: () => unknown }): void {
  const { hasNextPage, isFetchingNextPage, isError, fetchNextPage } = q;
  useEffect(() => {
    if (shouldFetchNextPage({ hasNextPage, isFetchingNextPage, isError })) {
      void fetchNextPage();
    }
  }, [hasNextPage, isFetchingNextPage, isError, fetchNextPage]);
}
